import {FormProvider, useForm} from "react-hook-form";

import {SearchBoxControlled} from "base/component/search";
import {EntityCounter} from "base/entity";

import {useList} from "base/provider";
import {useCallback} from "react";
import Stack from "@mui/material/Stack";

const EntityFilterForm = ({entityName}) => {
    const {filter, setFilter, setPage, size} = useList();

    const formMethods = useForm({
        defaultValues: {
            search: filter?.search || "",
        },
    });

    const handleChange = useCallback(
        attributeValue => {
            setPage(1);
            setFilter({...filter, ...attributeValue});
        },
        [filter]
    );

    return (
        <FormProvider {...formMethods}>
            <Stack direction="row" spacing={2} mb={1}>
                <SearchBoxControlled
                    name="search"
                    onChangeHandler={value => handleChange({search: value})}
                />
                <EntityCounter size={size} entityName={entityName} />
            </Stack>
        </FormProvider>
    );
};

export default EntityFilterForm;
